import React from "react";
import { BackButton } from "../../components/BackButton/BackButton";
import { Heading } from "../../components/Heading";

export const HowToInstallPage = () => {
  const baseClassname = "how-to-install";

  return (
    <div className={`${baseClassname}`}>
      <BackButton />
      <div>
        <Heading type="h1" label="How to install" />
        <br />
        <Heading type="h2" label="Guide" />
        <p>
          Read more detailed instructions and documentation on using or
          installing the distributed mobile apps.
        </p>
      </div>
      <div className={`${baseClassname}__link-list`}>
        <a
          href="https://developer.apple.com/documentation/xcode/distributing-your-app-to-registered-devices#Collect-device-identifiers-iOS-iPadOS-tvOS-watchOS"
          className={`${baseClassname}__link`}
        >
          Locate Device ID (UDID)
        </a>
        <a
          href="https://developer.apple.com/documentation/xcode/distributing-your-app-to-registered-devices#Register-devices-in-your-developer-account"
          className={`${baseClassname}__link`}
        >
          Registering a Device for Testing
        </a>
      </div>
    </div>
  );
};
